import { z } from 'zod'

/**
 * Non-empty trimmed string.
 *
 * Rejects `null`, empty strings, and whitespace-only strings.
 * Trims leading/trailing whitespace before validation.
 */
export const nonEmptyString = z.string().trim().min(1)
